export const _reducersActions = {
	counter: { onAgeUp: 'onAgeUp', onAgeDown: 'onAgeDown' },
	counterWeight: { onWeightUp: 'onWeightUp', onWeightDown: 'onWeightDown' }
}


